export default function carousel($carousel) {
  init($carousel)
}

function init ($carousel) {
  let preventClick = false

  let $container = $carousel.closest('.js-carousel-container')

  let carouselOptions = {
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true
  }

  switch ($carousel.getAttribute('data-carousel-type')) {
    case 'dots':
      carouselOptions.pageDots = true
      break
    case 'prevNext':
    default:
      carouselOptions.pageDots = false
      break
  }

  import(/* webpackChunkName: 'flickity' */ 'flickity-imagesloaded').then(Flickity => {
    let flkty = new Flickity($carousel, carouselOptions)

    flkty.on('staticClick', (e, pointer, element, index) => {
      if (index !== flkty.selectedIndex) {
        preventClick = true
        window.setTimeout(() => {
          preventClick = false
        }, 0)
        flkty.select(index)
      }
    })

    $carousel.addEventListener('click', e => {
      let $link = e.target.closest('a')
      if (!$link) return
      if (preventClick) {
        e.preventDefault()
      }
    })

    var $prev = $container.querySelector('.js-carousel-prev')
    if ($prev) {
      $prev.addEventListener('click', e => {
        flkty.previous()
      })
    }
    var $next = $container.querySelector('.js-carousel-next')
    if ($next) {
      $container.querySelector('.js-carousel-next').addEventListener('click', e => {
        flkty.next()
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/ui/carousel.js